import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import Logo from 'components/Icons/LogoGray';
const style = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: 'auto',
  height: 100,
  width: 100,
};

export default class StaticLoader extends Component {
  static propTypes = {
    style: PropTypes.object,
  };

  render() {
    const styleProps = this.props.style ? this.props.style : {};
    return <Logo style={{ ...style, ...styleProps }} />;
  }
}
